'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getPage;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _shouldFetchPage = require('../list/should-fetch-page');

var _shouldFetchPage2 = _interopRequireDefault(_shouldFetchPage);

var _page = require('../list/page');

var _page2 = _interopRequireDefault(_page);

var _throttledDispatch = require('./throttled-dispatch');

var _stateHelper = require('./_state-helper');

var _transformable2 = require('./_transformable');

var _transformable3 = _interopRequireDefault(_transformable2);

var _selectors3 = require('./_selectors');

var _selectors4 = _interopRequireDefault(_selectors3);

var _compact2 = require('./_compact');

var _compact3 = _interopRequireDefault(_compact2);

var _getRoot = require('./get-root');

var _getRoot2 = _interopRequireDefault(_getRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These arguments should not influence the contents
// of the retrieved list, so we blacklist them when hashing
var HASH_IGNORE = ['pageSize', 'page'];

var pageDefaults = {
    namespace: null,
    listName: 'all',
    fetch: 'fetchPage',
    storeName: '$store',
    condition: function condition() {
        return true;
    }
};

function getPage(pageSelector, listName) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    options = (0, _extends3.default)({}, pageDefaults, options);

    var _options = options,
        namespace = _options.namespace,
        storeName = _options.storeName;
    var _options2 = options,
        fetch = _options2.fetch,
        condition = _options2.condition;

    var _selectors2 = (0, _selectors4.default)(pageSelector, (0, _extends3.default)({}, options, { listName: listName })),
        getSelection = _selectors2.getSelection,
        getListName = _selectors2.getListName,
        getParams = _selectors2.getParams,
        getHash = _selectors2.getHash;

    if (namespace && typeof fetch === 'string') fetch = namespace + '/' + fetch;

    return (0, _transformable3.default)(function () {
        var opts = getParams(this);
        var page = getSelection(this, opts) || 1;
        var listName = getListName(this, opts);
        var store = (0, _get3.default)(this, storeName);
        var allowFetch = condition(this, opts);
        var hash = getHash((0, _omit3.default)(opts, HASH_IGNORE));
        var dispatch = (0, _throttledDispatch.wrapDispatch)(store.dispatch);

        if (page < 1) throw new Error('page must be greater than 0');

        (0, _stateHelper.updateListHash)(store, namespace, listName, hash);

        var root = (0, _getRoot2.default)(store.state, namespace);
        if (allowFetch && (0, _shouldFetchPage2.default)(root, listName, page, opts)) dispatch(fetch, (0, _extends3.default)({ listName: listName, page: page }, opts));

        var entries = (0, _page2.default)(root, listName, page, opts);
        return (0, _compact3.default)(entries);
    });
}